import deckSlide from "./deck.slice";

export * from "./deck.saga";
export * from "./deck.slice";

export default deckSlide.reducer;
